import { batch, signal } from "@preact/signals-react"

// Data to analyze (columns + rows + metadata)
export const aiInsightsData = signal(null)

// Streaming response
export const aiInsightsText = signal('')
export const aiInsightsError = signal(null)
export const isAnalyzingAi = signal(false)

// Drawer visibility (decoupled from data presence)
export const isOpenAiInsights = signal(false)

// Page data provider — pages register a function that returns their current data
// The function should return { columns, rows, metadata, question, language } or null
export const aiInsightsProvider = signal(null)

// Open drawer with data and start analysis
export const openAiInsights = ({ columns, rows, metadata, question, language }) => {
	batch(() => {
		aiInsightsData.value = { columns, rows, metadata, question, language }
		isOpenAiInsights.value = true
	})
}

// Toggle drawer — if opening and no prior data, try the page provider
export const toggleAiInsights = () => {
	if (isOpenAiInsights.value) {
		isOpenAiInsights.value = false
		return
	}

	// If already analyzing or have previous results, just re-open
	if (isAnalyzingAi.value || aiInsightsText.value) {
		isOpenAiInsights.value = true
		return
	}

	// Try to get data from the current page's provider
	const provider = aiInsightsProvider.value
	if (provider) {
		const data = provider()
		if (data) {
			batch(() => {
				aiInsightsData.value = data
				isOpenAiInsights.value = true
			})
			return
		}
	}

	// No data available — open drawer anyway (shows empty state)
	isOpenAiInsights.value = true
}

// Close drawer (keep data for re-open)
export const closeAiInsights = () => {
	isOpenAiInsights.value = false
}

// Full reset (close + clear data)
export const resetAiInsights = () => batch(() => {
	isOpenAiInsights.value = false
	aiInsightsData.value = null
	aiInsightsText.value = ''
	aiInsightsError.value = null
	isAnalyzingAi.value = false
})
